import { render, staticRenderFns } from "./TemposMarcacao.vue?vue&type=template&id=3faed0cd&"
import script from "./TemposMarcacao.vue?vue&type=script&lang=js&"
export * from "./TemposMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports